import { styled } from '@spazious/dollhouse-theme';
import { PaletteColors, SizingNames } from '@spazious/dollhouse-theme';

import { BaseCSSPropertiesList, BaseExtendProps, createBase } from '../Base/index.js';

export type InputBaseElement = HTMLInputElement;
export interface InputBaseProps
  extends Omit<BaseExtendProps<React.InputHTMLAttributes<HTMLInputElement>>, 'size' | 'color'> {
  color?: PaletteColors;
  size?: SizingNames;
  fullWidth?: boolean;
}

export const InputHTMLAttributesList: (keyof React.InputHTMLAttributes<HTMLInputElement>)[] = [
  'accept',
  'alt',
  'autoComplete',
  'capture',
  'checked',
  'disabled',
  'enterKeyHint',
  'form',
  'formAction',
  'formEncType',
  'formMethod',
  'formNoValidate',
  'formTarget',
  'height',
  'list',
  'max',
  'maxLength',
  'min',
  'minLength',
  'multiple',
  'name',
  'pattern',
  'placeholder',
  'readOnly',
  'required',
  'size',
  'src',
  'step',
  'type',
  'value',
  'width',
  'onChange',
];

export const InputBasePropsList: (keyof InputBaseProps)[] = [
  ...BaseCSSPropertiesList,
  ...InputHTMLAttributesList,
  'color',
  'size',
  'fullWidth',
];

export const InputBase = styled(createBase('input')).withConfig({
  displayName: 'InputBase',
})<InputBaseProps>`
  --spacing-input-padding-small: 4px;
  --spacing-input-padding-medium: 8px;
  --spacing-input-padding-large: 12px;
  transition: background-color, color, box-shadow, border 0.3s ease-in-out;
  display: inline-flex;
  outline: none;
  border: none;
  margin: 0;
  padding: ${({ size = 'medium' }) => `var(--spacing-input-padding-${size})`};
  color: var(--spz-sys-color-on-surface);
  border-radius: var(--shape-rounded-radius);
  background-color: var(--spz-sys-color-surface);
  border: 1px solid var(--spz-sys-color-outline);
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  ${({ color }) => color && `color: var(--spz-sys-color-${color});`}
  &:hover {
    color: var(--spz-sys-color-on-surface-variant);
    background-color: var(--spz-sys-color-surface-variant);
    border: 1px solid var(--spz-sys-color-surface-container-high);
  }
  &:focus {
    color: var(--spz-sys-color-on-surface-variant);
    background-color: var(--spz-sys-color-surface-variant);
    border: 1px solid var(--spz-sys-color-primary);
    box-shadow: 0 0 0 1px var(--spz-sys-color-primary);
  }
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed !important;
    background-color: var(--spz-sys-color-surface-container-highest) !important;
    border: 1px solid var(--spz-sys-color-surface-container-high) !important;
  `}
`;
